let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("beF0E"), load("8dYdP")]).then(() => parcelRequire('gef2L'));